/*
  KP: REVIEWS ON PRODUCT PAGES, ALL REVIEWS COMBINED (16 Oct 2026, Sana: "do what BURGA do
  and put reviews (as all reviews combined) in the drop downs", then "combine all wise review").

  - A "Reviews" dropdown, among the page's other dropdowns (straight after Description),
    with the store's rating over EVERY product's reviews in WiseReviews (10,564 reviews,
    4.9 on 16 Oct 2026), a bar per star rating, and the reviews themselves, newest first,
    five at a time ("Show more reviews" fetches the next ones). Each review shows its stars,
    date, words, photos and the product it was for. Reviews with no words (stars only) are
    counted in the rating but not listed.
  - Under the product title, the per-product stars ("1 reviews") are replaced with the
    combined rating ("4.9 · 10,564 reviews"); pressing it opens the Reviews dropdown.
  - The old per-product WiseReviews block at the bottom of the page is hidden.
  - Also: the "Double-check your phone model and case type" note above Add to Cart is hidden.

  WHERE THE REVIEWS COME FROM: WiseReviews' own public reviews address (the one its widget
  uses), asked for all product reviews with no product named. The numbers follow
  WiseReviews by themselves. Product names come from the store (Storefront API).
  If WiseReviews cannot be reached, the dropdown falls back to the Judge.me numbers and
  newest 25 reviews that snippets/kp-extras.liquid (part 13) puts in the page as
  window.KP_REVIEWS. WiseReviews' list also holds each reviewer's email address; it is
  never read or shown here.

  Settings: SORT (WiseReviews' order: DATE_NEWEST_FIRST, RECOMMENDED, RATING_HIGHEST_FIRST,
  HELPFUL_HIGHEST_FIRST) and PAGE (reviews shown per "Show more").
  - On the custom case builder, the rating lines open the same reviews in a panel
    (builderReviews, 25 Oct 2026).
  Styles are at the bottom of this file. Delete the part 13 lines in kp-extras.liquid to
  switch all of this off.
*/
(function () {
  'use strict';

  var WISE = 'https://wise-reviews.codexapps.co/api/proxy/reviews';
  var SORT = 'DATE_NEWEST_FIRST';
  var PAGE = 5;
  var API = '/api/2025-07/graphql.json';

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null) node.textContent = text;
    return node;
  }

  // Review text can arrive with HTML entities in it (&#39;).
  function decode(text) {
    var box = document.createElement('textarea');
    box.innerHTML = String(text || '');
    return box.value;
  }

  function thousands(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // ---- The "Double-check your phone model and case type" note: hidden ----

  function hideDoubleCheck() {
    each(document.querySelectorAll('.product-blocks .product__block'), function (block) {
      if (/^\s*Double-check your/i.test(block.textContent)) {
        block.style.display = 'none';
        block.setAttribute('data-kp-hidden', 'double-check');
      }
    });
  }

  hideDoubleCheck();

  // ---- Where the reviews come from ----

  // One page of WiseReviews' combined product reviews, as
  // { count, rating, split: {5: %, ...}, last, reviews: [{ s, t, b, n, d, v, img: [], pid }] }.
  function wisePage(page) {
    var url = new URL(WISE);
    url.searchParams.set('shop', (window.Shopify && window.Shopify.shop) || location.hostname);
    url.searchParams.set('type', 'product_reviews');
    url.searchParams.set('sort_by', SORT);
    url.searchParams.set('page', page);

    return fetch(url.toString())
      .then(function (response) {
        if (!response.ok) throw new Error('reviews');
        return response.json();
      })
      .then(function (json) {
        var split = {};
        var pct = json.rating_percentage || {};
        [5, 4, 3, 2, 1].forEach(function (star) {
          split[star] = parseFloat(pct[star + '_star']) || 0;
        });

        return {
          count: (json.meta && json.meta.total) || 0,
          rating: parseFloat(json.average_rating) || 0,
          split: split,
          last: (json.meta && json.meta.last_page) || page,
          reviews: (json.data || []).map(function (review) {
            return {
              s: review.rating,
              t: review.title,
              b: review.body,
              n: review.reviewer_name,
              d: review.date,
              v: !!review.verified,
              img: review.media_urls || [],
              pid: review.product_id
            };
          })
        };
      });
  }

  // The Judge.me data put in the page by kp-extras.liquid, in the same shape.
  function judgeData() {
    var data = window.KP_REVIEWS;
    if (!data || !data.count || !data.reviews || !data.reviews.length) return null;

    return {
      count: parseInt(data.count, 10),
      rating: parseFloat(data.rating),
      split: null,
      last: 1,
      judge: true,
      reviews: data.reviews.map(function (review) {
        return { s: review.s, t: review.t, b: review.b, n: review.n, d: review.d, v: review.v, img: review.i ? [review.i] : [], name: review.p, url: review.u };
      })
    };
  }

  // Product names and addresses for the products the reviews were for: { id: { title, url } }.
  var products = {};

  function loadProducts(ids) {
    var wanted = ids.filter(function (id) {
      return id && !products[id];
    });
    if (!wanted.length) return Promise.resolve();

    return fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        query: 'query ($ids: [ID!]!) { nodes(ids: $ids) { ... on Product { id title onlineStoreUrl } } }',
        variables: { ids: wanted.map(function (id) { return 'gid://shopify/Product/' + id; }) }
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        ((json && json.data && json.data.nodes) || []).forEach(function (node) {
          if (node && node.id) products[node.id.split('/').pop()] = { title: node.title, url: node.onlineStoreUrl };
        });
      })
      .catch(function () {});
  }

  // ---- Drawing ----

  // Five stars, filled to the rating (4.5 shows four and a half).
  function stars(value, size) {
    var box = el('span', 'kp-rev__stars');
    box.setAttribute('aria-label', value + ' out of 5 stars');
    box.style.setProperty('--kp-rev-fill', Math.max(0, Math.min(100, (value / 5) * 100)) + '%');
    if (size) box.style.fontSize = size + 'px';
    box.appendChild(el('span', 'kp-rev__stars-back', '★★★★★'));
    box.appendChild(el('span', 'kp-rev__stars-front', '★★★★★'));
    return box;
  }

  function dateOf(value) {
    if (!value) return '';
    // WiseReviews already sends "Sep 15, 2026"; Judge.me sends a full date.
    if (!/^\d{4}-/.test(value)) return value;
    try {
      return new Date(value).toLocaleDateString(document.documentElement.lang || 'en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    } catch (e) {
      return '';
    }
  }

  var CHEVRON = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M1.875 7.438 12 17.563 22.125 7.438" stroke="currentColor" stroke-width="2"></path></svg>';

  function card(review) {
    var item = el('div', 'kp-rev__item');
    var head = el('div', 'kp-rev__item-head');
    head.appendChild(stars(review.s, 14));
    if (review.d) head.appendChild(el('span', 'kp-rev__date', dateOf(review.d)));
    item.appendChild(head);

    if (review.t) item.appendChild(el('div', 'kp-rev__title', decode(review.t)));
    if (review.b) item.appendChild(el('p', 'kp-rev__body', decode(review.b)));

    if (review.img && review.img.length) {
      var photos = el('div', 'kp-rev__photos');
      review.img.slice(0, 4).forEach(function (src) {
        var photo = el('img', 'kp-rev__photo');
        photo.src = src;
        photo.alt = '';
        photo.loading = 'lazy';
        photo.width = 80;
        photo.height = 80;
        photos.appendChild(photo);
      });
      item.appendChild(photos);
    }

    var foot = el('div', 'kp-rev__foot');
    foot.appendChild(el('span', 'kp-rev__name', decode(review.n) || 'Anonymous'));
    if (review.v) foot.appendChild(el('span', 'kp-rev__verified', 'Verified buyer'));
    item.appendChild(foot);

    var product = review.pid ? products[review.pid] : null;
    var name = product ? product.title : review.name;
    var url = product ? product.url : review.url;
    if (name) {
      var link = url ? el('a', 'kp-rev__product') : el('span', 'kp-rev__product');
      link.textContent = decode(name);
      if (url) link.href = url;
      item.appendChild(link);
    }

    return item;
  }

  // The bar per star rating (WiseReviews only).
  function bars(split) {
    var box = el('div', 'kp-rev__bars');
    [5, 4, 3, 2, 1].forEach(function (star) {
      var row = el('div', 'kp-rev__bar');
      row.appendChild(el('span', 'kp-rev__bar-label', star + '★'));
      var track = el('span', 'kp-rev__bar-track');
      var fill = el('span', 'kp-rev__bar-fill');
      fill.style.width = split[star] + '%';
      track.appendChild(fill);
      row.appendChild(track);
      row.appendChild(el('span', 'kp-rev__bar-pct', split[star] + '%'));
      box.appendChild(row);
    });
    return box;
  }

  function build(first) {
    var rating = Math.round(first.rating * 10) / 10;
    var box = el('div', 'accordion product-blocks__accordion kp-rev');
    box.id = 'kp-reviews';

    var inner = el('div', 'accordion__inner');
    inner.setAttribute('data-open', 'false');

    var label = el('button', 'kp-rev__label');
    label.type = 'button';
    label.setAttribute('aria-expanded', 'false');
    label.setAttribute('aria-controls', 'kp-reviews-content');

    label.appendChild(el('h2', 'ff-heading fs-heading-5-base kp-rev__heading', 'Reviews'));

    var summary = el('span', 'kp-rev__mini');
    summary.appendChild(stars(rating, 13));
    summary.appendChild(el('span', 'kp-rev__mini-count', '(' + thousands(first.count) + ')'));
    label.appendChild(summary);

    var icon = el('span', 'kp-rev__chevron');
    icon.innerHTML = CHEVRON;
    label.appendChild(icon);
    inner.appendChild(label);

    var content = el('div', 'kp-rev__content');
    content.id = 'kp-reviews-content';
    content.hidden = true;

    var top = el('div', 'kp-rev__summary');
    var score = el('div', 'kp-rev__score-box');
    score.appendChild(el('span', 'kp-rev__score', rating.toFixed(1)));
    var topText = el('div', 'kp-rev__summary-text');
    topText.appendChild(stars(rating, 18));
    topText.appendChild(el('span', 'kp-rev__summary-count', 'Based on ' + thousands(first.count) + ' reviews across all our products'));
    score.appendChild(topText);
    top.appendChild(score);
    if (first.split) top.appendChild(bars(first.split));
    content.appendChild(top);

    var list = el('div', 'kp-rev__list');
    content.appendChild(list);

    var more = el('button', 'kp-rev__more', 'Show more reviews');
    more.type = 'button';
    content.appendChild(more);

    // Reviews waiting to be shown, and the next WiseReviews page to ask for.
    var queue = [];
    var nextPage = 2;
    var busy = false;

    function take(reviews) {
      reviews.forEach(function (review) {
        if (review.b || review.t) queue.push(review);
      });
    }

    function fill() {
      if (queue.length >= PAGE || first.judge || nextPage > first.last) return Promise.resolve();
      return wisePage(nextPage++)
        .then(function (page) {
          take(page.reviews);
          return fill();
        })
        .catch(function () {
          nextPage = first.last + 1;
        });
    }

    function showMore() {
      if (busy) return;
      busy = true;
      more.disabled = true;

      fill()
        .then(function () {
          var batch = queue.splice(0, PAGE);
          return loadProducts(batch.map(function (review) { return review.pid; })).then(function () {
            batch.forEach(function (review) {
              list.appendChild(card(review));
            });
          });
        })
        .then(function () {
          busy = false;
          more.disabled = false;
          more.hidden = !queue.length && (first.judge || nextPage > first.last);
        });
    }

    take(first.reviews);
    more.addEventListener('click', showMore);
    showMore();

    inner.appendChild(content);
    box.appendChild(inner);

    label.addEventListener('click', function () {
      setOpen(box, content.hidden);
    });

    box.kpRating = rating;
    box.kpCount = first.count;
    return box;
  }

  function setOpen(box, open) {
    var inner = box.querySelector('.accordion__inner');
    var label = box.querySelector('.kp-rev__label');
    var content = box.querySelector('.kp-rev__content');
    content.hidden = !open;
    inner.setAttribute('data-open', open ? 'true' : 'false');
    label.setAttribute('aria-expanded', open ? 'true' : 'false');
    box.classList.toggle('is-open', open);
  }

  // ---- The rating under the title ----

  function titleRating(box) {
    var line = el('button', 'kp-rev__line');
    line.type = 'button';
    line.appendChild(stars(box.kpRating, 16));
    line.appendChild(el('span', 'kp-rev__line-text', box.kpRating.toFixed(1) + ' · ' + thousands(box.kpCount) + ' reviews'));
    line.addEventListener('click', function () {
      setOpen(box, true);
      box.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    return line;
  }

  function place(first) {
    // The page has a few block areas (the photo column has its own, for phones and for
    // computers); the one wanted is the one holding the dropdowns.
    var blocks = Array.prototype.filter.call(document.querySelectorAll('.product-blocks'), function (area) {
      return !!area.querySelector('.accordion');
    })[0];
    if (!blocks || blocks.querySelector('#kp-reviews')) return;

    var accordions = blocks.querySelectorAll('.product-blocks__accordion, .accordion');
    var description = blocks.querySelector('#description');
    var anchor = description || accordions[0];
    if (!anchor) return;

    var box = build(first);
    anchor.parentNode.insertBefore(box, anchor.nextSibling);

    // Under the title: the per-product stars give way to the combined rating.
    each(blocks.querySelectorAll('[id*="star_rating"], .jdgm-widget.jdgm-preview-badge'), function (old) {
      if (old.getAttribute('data-kp-rev-done')) return;
      old.setAttribute('data-kp-rev-done', '1');
      old.style.display = 'none';
      old.parentNode.insertBefore(titleRating(box), old.nextSibling);
    });
  }

  function start() {
    // The per-product reviews block further down the page: hidden (the dropdown has them).
    each(document.querySelectorAll('[id*="wisereviews_reviews_importer_product_reviews"]'), function (old) {
      var section = old.closest('.shopify-section');
      (section || old).style.display = 'none';
    });

    if (!document.querySelector('.product-blocks .accordion')) return;

    wisePage(1)
      .then(function (first) {
        if (!first.count) throw new Error('empty');
        return loadProducts(first.reviews.map(function (review) { return review.pid; })).then(function () {
          return first;
        });
      })
      .catch(function () {
        return judgeData();
      })
      .then(function (first) {
        if (first) place(first);
      });
  }

  var css =
    // The row is the same height as the theme's dropdowns: the theme's own box padding only,
    // nothing added on the label (Sana, 16 Oct: it was thicker than the others).
    '.kp-rev__label{display:flex;align-items:center;gap:10px;width:100%;padding:0;border:0;background:none;color:inherit;text-align:left;cursor:pointer;font:inherit;line-height:1}' +
    '.kp-rev__heading{flex:1 1 auto;margin:0;line-height:1}' +
    '.kp-rev__mini{display:inline-flex;align-items:center;gap:5px;font-size:13px;line-height:1;white-space:nowrap}' +
    '.kp-rev__chevron{display:inline-flex;width:15px;height:14px;transition:transform .2s}' +
    '.kp-rev__chevron svg{width:15px;height:14px}' +
    '.kp-rev.is-open .kp-rev__chevron{transform:rotate(180deg)}' +
    '.kp-rev__content{padding:14px 0 4px}' +
    '.kp-rev__stars{position:relative;display:inline-block;line-height:1;letter-spacing:1px;color:#e2ddd6}' +
    '.kp-rev__stars-front{position:absolute;top:0;left:0;overflow:hidden;width:var(--kp-rev-fill,100%);color:#111;white-space:nowrap}' +
    '.kp-rev__summary{display:flex;flex-wrap:wrap;align-items:center;gap:12px 20px;padding:12px 14px;border-radius:12px;background:#faf7f3;margin-bottom:6px}' +
    '.kp-rev__score-box{display:flex;align-items:center;gap:12px}' +
    '.kp-rev__score{font-size:30px;font-weight:700;line-height:1}' +
    '.kp-rev__summary-text{display:flex;flex-direction:column;gap:4px}' +
    '.kp-rev__summary-count{font-size:13px;color:#6b6b6b}' +
    '.kp-rev__bars{flex:1 1 180px;display:flex;flex-direction:column;gap:3px;min-width:160px}' +
    '.kp-rev__bar{display:flex;align-items:center;gap:8px;font-size:12px;color:#555}' +
    '.kp-rev__bar-label{width:22px}' +
    '.kp-rev__bar-track{flex:1 1 auto;height:6px;border-radius:3px;background:#e9e3db;overflow:hidden}' +
    '.kp-rev__bar-fill{display:block;height:100%;background:#111}' +
    '.kp-rev__bar-pct{width:30px;text-align:right}' +
    '.kp-rev__item{padding:14px 0;border-bottom:1px solid #eee}' +
    '.kp-rev__item-head{display:flex;align-items:center;justify-content:space-between;gap:8px}' +
    '.kp-rev__date{font-size:12px;color:#8a8a8a}' +
    '.kp-rev__title{margin-top:8px;font-weight:700;font-size:14px}' +
    '.kp-rev__body{margin:4px 0 0;font-size:14px;line-height:1.5}' +
    '.kp-rev__photos{display:flex;gap:6px;margin-top:8px}' +
    '.kp-rev__photo{display:block;width:80px;height:80px;border-radius:8px;object-fit:cover}' +
    '.kp-rev__foot{display:flex;align-items:center;gap:8px;margin-top:8px;font-size:12.5px;color:#555}' +
    '.kp-rev__name{font-weight:600;color:#111}' +
    '.kp-rev__verified{padding:2px 7px;border-radius:999px;background:#eef6ef;color:#2e7d43;font-size:11px;font-weight:600}' +
    '.kp-rev__product{display:inline-block;margin-top:4px;font-size:12.5px;color:#6b6b6b;text-decoration:underline}' +
    '.kp-rev__more{display:block;width:100%;margin-top:12px;padding:11px;border:1.5px solid #111;border-radius:999px;background:#fff;color:#111;font:inherit;font-size:14px;font-weight:600;cursor:pointer}' +
    '.kp-rev__more[disabled]{opacity:.5}' +
    '.kp-rev__line{display:flex;align-items:center;gap:7px;margin:0 0 6px;padding:0;border:0;background:none;color:inherit;font:inherit;font-size:14px;cursor:pointer}' +
    // Even 8px gaps between the title, price, "Made to Order" line and the rating (Sana, 16 Oct:
    // the theme had 10, 4 and 6).
    '.product-blocks .product__block--product-header .product__title{margin-bottom:0}' +
    '.product-blocks .product__block--product-header .product__price-and-ratings{margin-top:8px}' +
    '.product-blocks .product__block.product__block--product-header{margin-bottom:8px}' +
    '.product-blocks .inventory-counter.product__block{margin-bottom:8px}' +
    '.kp-rev__line-text{text-decoration:underline;text-underline-offset:2px}';

  // ---- The custom case builder (Design Your Own Case, sections/kp-case-builder.liquid) ----
  // (25 Oct 2026, Sana: pressing the rating did nothing; "open in a panel" with the same reviews
  // as the other pages.) Its "4.9 · 10,564 reviews" lines open a panel with the combined
  // reviews, drawn exactly like the Reviews dropdown above, and show the live numbers.

  function builderReviews() {
    var root = document.getElementById('kp-builder');
    if (!root || root.getAttribute('data-kp-rev-done')) return;
    root.setAttribute('data-kp-rev-done', '1');
    var lines = root.querySelectorAll('.rating');
    if (!lines.length) return;

    var scrim = el('div', 'kp-rvp');
    scrim.hidden = true;
    var sheet = el('div', 'kp-rvp__sheet');
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-labelledby', 'kp-rvp-title');
    var head = el('div', 'kp-rvp__head');
    var title = el('h3', 'kp-rvp__title', 'Reviews');
    title.id = 'kp-rvp-title';
    var close = el('button', 'kp-rvp__close', '×');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close reviews');
    head.appendChild(title);
    head.appendChild(close);
    var body = el('div', 'kp-rvp__body');
    body.appendChild(el('p', 'kp-rvp__msg', 'Loading reviews…'));
    sheet.appendChild(head);
    sheet.appendChild(body);
    scrim.appendChild(sheet);
    document.body.appendChild(scrim);

    var opener = null;
    function show() {
      opener = document.activeElement;
      scrim.hidden = false;
      document.documentElement.classList.add('kp-rvp-open');
      setTimeout(function () { close.focus({ preventScroll: true }); }, 30);
    }
    function hide() {
      scrim.hidden = true;
      document.documentElement.classList.remove('kp-rvp-open');
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    }
    close.addEventListener('click', hide);
    scrim.addEventListener('click', function (e) { if (e.target === scrim) hide(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !scrim.hidden) hide(); });

    each(lines, function (line) {
      line.setAttribute('role', 'button');
      line.setAttribute('tabindex', '0');
      line.setAttribute('aria-haspopup', 'dialog');
      line.removeAttribute('href');
      line.classList.add('kp-rvp__trigger');
      line.addEventListener('click', function (e) { e.preventDefault(); show(); });
      line.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); show(); }
      });
    });

    function fail() {
      body.innerHTML = '';
      body.appendChild(el('p', 'kp-rvp__msg', 'Reviews couldn’t load just now. Please try again in a moment.'));
    }

    wisePage(1)
      .then(function (first) {
        if (!first.count) throw new Error('empty');
        return loadProducts(first.reviews.map(function (review) { return review.pid; })).then(function () {
          return first;
        });
      })
      .catch(function () {
        return judgeData();
      })
      .then(function (first) {
        if (!first) { fail(); return; }
        var rating = Math.round(first.rating * 10) / 10;

        // the lines on the builder show the live numbers too
        each(lines, function (line) {
          var text = line.querySelector('span:last-child');
          if (!text) return;
          text.innerHTML = '';
          text.appendChild(el('b', null, rating.toFixed(1)));
          text.appendChild(document.createTextNode(' · ' + thousands(first.count) + ' reviews'));
        });

        body.innerHTML = '';
        var top = el('div', 'kp-rev__summary');
        var score = el('div', 'kp-rev__score-box');
        score.appendChild(el('span', 'kp-rev__score', rating.toFixed(1)));
        var topText = el('div', 'kp-rev__summary-text');
        topText.appendChild(stars(rating, 18));
        topText.appendChild(el('span', 'kp-rev__summary-count', 'Based on ' + thousands(first.count) + ' reviews across all our products'));
        score.appendChild(topText);
        top.appendChild(score);
        if (first.split) top.appendChild(bars(first.split));
        body.appendChild(top);

        var list = el('div', 'kp-rev__list');
        body.appendChild(list);
        var more = el('button', 'kp-rev__more', 'Show more reviews');
        more.type = 'button';
        body.appendChild(more);

        var queue = [];
        var nextPage = 2;
        var busy = false;

        function take(reviews) {
          reviews.forEach(function (review) {
            if (review.b || review.t) queue.push(review);
          });
        }

        function fill() {
          if (queue.length >= PAGE || first.judge || nextPage > first.last) return Promise.resolve();
          return wisePage(nextPage++)
            .then(function (page) {
              take(page.reviews);
              return fill();
            })
            .catch(function () {
              nextPage = first.last + 1;
            });
        }

        function showMore() {
          if (busy) return;
          busy = true;
          more.disabled = true;
          fill()
            .then(function () {
              var batch = queue.splice(0, PAGE);
              return loadProducts(batch.map(function (review) { return review.pid; })).then(function () {
                batch.forEach(function (review) {
                  list.appendChild(card(review));
                });
              });
            })
            .then(function () {
              busy = false;
              more.disabled = false;
              more.hidden = !queue.length && (first.judge || nextPage > first.last);
            });
        }

        take(first.reviews);
        more.addEventListener('click', showMore);
        showMore();
      });
  }

  css +=
    '.kp-rvp{position:fixed;inset:0;z-index:2147483000;background:rgba(43,30,20,.38);display:flex;align-items:flex-end;justify-content:center}' +
    '.kp-rvp[hidden]{display:none}' +
    '.kp-rvp__sheet{width:min(100%,560px);max-height:88vh;max-height:88svh;overflow:auto;overscroll-behavior:contain;background:#fff;color:#2b2a28;border-radius:24px 24px 0 0;padding:18px 20px calc(20px + env(safe-area-inset-bottom,0px));font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;box-sizing:border-box}' +
    '@media (min-width:700px){.kp-rvp{align-items:center}.kp-rvp__sheet{border-radius:24px}}' +
    '.kp-rvp__head{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:12px}' +
    '.kp-rvp__title{margin:0;font:700 19px/1.2 "Helvetica Neue",Helvetica,Arial,sans-serif;letter-spacing:0;text-transform:none;color:inherit}' +
    '.kp-rvp__close{width:40px;height:40px;flex:none;border-radius:50%;border:0;background:#f8f2ec;color:#2b2a28;font-size:22px;line-height:1;cursor:pointer;padding:0}' +
    '.kp-rvp__msg{margin:0;padding:18px 0;text-align:center;font-size:14px;color:#7a726b}' +
    '.kp-rvp-open,.kp-rvp-open body{overflow:hidden}' +
    '#kp-builder .kp-rvp__trigger{cursor:pointer}' +
    '#kp-builder .q.locked .kp-rvp__trigger{pointer-events:auto}' +
    '#kp-builder .rating.sm.kp-rvp__trigger span:last-child{text-decoration:underline;text-underline-offset:3px}';

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(); builderReviews(); });
  else { start(); builderReviews(); }
})();
